import api from "../../domain/api";
import {
  GET_PROCESSS_STATED,
  GET_PROCESSS,
  GET_PROCESSS_ENDED,
  ADD_PROCESS_STATED,
  ADD_PROCESS,
  ADD_PROCESS_ENDED,
  EDIT_PROCESS_STATED,
  EDIT_PROCESS,
  EDIT_PROCESS_ENDED,
  GET_PROCESS_STATED,
  GET_PROCESS,
  GET_PROCESS_ENDED,
  GET_ALL_PROCESSS_STATED,
  GET_ALL_PROCESSS,
  GET_ALL_PROCESSS_ENDED,
} from "../types/process_type";
import * as qs from "qs";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";

export const addProcess = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_PROCESS_STATED,
    });
    const { data } = await api.post(`/processs`, formData);
    dispatch({
      type: ADD_PROCESS,
      payload: data,
    });
    dispatch({
      type: ADD_PROCESS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_PROCESS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getProcesss =
  ({ pageNumber = ""}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_PROCESSS_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/processs?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_PROCESSS,
        payload: data,
      });
      dispatch({
        type: GET_PROCESSS_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_PROCESSS_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getProcess = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_PROCESS_STATED,
    });
    const { data } = await api.get(`/processs/${id}`);

    dispatch({
      type: GET_PROCESS,
      payload: data,
    });
    dispatch({
      type: GET_PROCESS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_PROCESS_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editProcess = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_PROCESS_STATED,
    });
    const { data } = await api.put(`/processs/${id}`, formData);
    dispatch({
      type: EDIT_PROCESS,
      payload: data,
    });
    dispatch({
      type: EDIT_PROCESS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_PROCESS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteProcess = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/processs/${id}`);
    dispatch(setAlert("Process Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllProcesss = ({ term, value }) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ALL_PROCESSS_STATED,
    });
    const { data } = await api.get(`/processs/all?term=${term}&value=${value}`);

    dispatch({
      type: GET_ALL_PROCESSS,
      payload: data,
    });
    dispatch({
      type: GET_ALL_PROCESSS_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PROCESSS_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {};
